import { useEffect, useState } from "react";
import { load } from "@cashfreepayments/cashfree-js";
import config from "@nusrif/config";

export const useCashfreeSDK = () => {
  const [cashfree, setCashfree] = useState<any>(null);

  useEffect(() => {
    const init = async () => {
      const sdk = await load({ mode: config.api.cashfree as "sandbox" | "production" });
      setCashfree(sdk);
    };
    init();
  }, []);

  return cashfree;
};
